import React from "react";
import { Link } from "react-router-dom";
import { BrandWordmark, BrandMark } from "@/components/BrandMark";
import { Search, Map, ShieldCheck, ArrowRight } from "lucide-react";

const Card = ({ icon: Icon, title, text, to, testid }) => (
  <Link to={to} data-testid={testid} className="cad-panel p-5 block group">
    <div className="w-10 h-10 rounded-sm cad-glass flex items-center justify-center mb-4">
      <Icon size={20} className="text-[#C99A2E]" strokeWidth={1.6} />
    </div>
    <div className="font-display text-lg font-bold text-[#F6F8FA]">{title}</div>
    <div className="text-[13px] text-[#B3C2CC] mt-1">{text}</div>
    <div className="mt-3 text-[12px] text-[#C99A2E] inline-flex items-center gap-1">Open <ArrowRight size={12} /></div>
  </Link>
);

export const PublicPortal = () => (
  <div className="min-h-screen relative">
    <div className="cad-topo"></div>
    <header className="relative z-10 flex items-center justify-between px-6 lg:px-12 pt-8 pb-2">
      <BrandMark size={160} />
      <div className="flex gap-3">
        <Link to="/" className="cad-btn-outline px-4 py-2 rounded-sm text-[13px]">Home</Link>
        <Link to="/login" className="cad-btn-primary px-4 py-2 rounded-sm text-[13px]" data-testid="portal-signin">Officer sign in</Link>
      </div>
    </header>
    <main className="relative z-10 px-6 lg:px-12 py-12">
      <div className="cad-chip cad-chip-gold mb-5">Public Cadastre360™ Portal</div>
      <h1 className="font-display text-4xl lg:text-5xl font-bold text-[#F6F8FA] tracking-tight max-w-3xl">
        Zimbabwe's public window into land parcels, surveys and mineral rights.
      </h1>
      <p className="text-[14px] text-[#B3C2CC] mt-4 max-w-2xl leading-relaxed">
        Search parcel and mineral-right information, track application status, verify certificates and download
        legally publishable documents. Personal identity information and confidential commercial data are protected.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
        <Card icon={Search} title="Public Search" text="Search parcels, mining rights, licences by reference, applicant or district." to="/portal/search" testid="portal-card-search" />
        <Card icon={Map} title="Interactive Map" text="Explore mineral-right polygons and parcel boundaries across all provinces." to="/portal/map" testid="portal-card-map" />
        <Card icon={ShieldCheck} title="Verify Certificate" text="Scan a QR or paste a reference to verify a Cadastre360 certificate." to="/verify/ZW-LIC-030001" testid="portal-card-verify" />
      </div>

      <div className="mt-14 cad-panel p-6">
        <div className="font-mono-cad text-[10px] uppercase tracking-[0.24em] text-[#7C93A5]">Public notice</div>
        <div className="font-display text-lg font-bold text-[#F6F8FA] mt-2">
          Demonstration Environment — Fictional and Synthetic Data
        </div>
        <p className="text-[13px] text-[#B3C2CC] mt-2 leading-relaxed">
          This portal is currently operated as a national capability demonstration. Nothing in this environment
          constitutes an official government register or a legally authoritative decision. Verified public
          instruments will be introduced once the platform is formally adopted by an authorised authority.
        </p>
      </div>
    </main>
    <footer className="relative z-10 px-6 lg:px-12 py-8 border-t cad-hairline mt-10 text-[11px] font-mono-cad uppercase tracking-[0.22em] text-[#5F7688]">
      Cadastre360™ · Built on the THOM360™ Enterprise Platform Framework
    </footer>
  </div>
);
